import { HotelInformation, RoomType } from '../booking/my-booking-model';
import { PaymentMethodDetail, TaxAddressInformation } from '../booking/my-booking-model-v2';
export class BookingApprovalDetailModel {
  bookingId: number;
  bookingDate: Date;
  checkInDate: Date;
  checkOutDate: Date;
  night: number;
  room: number;
  totalMaxAdult: number;
  totalMaxChild: number;
  checkInTimeFrom: string;
  checkInTimeUntil: string;
  checkOutTimeFrom: string;
  checkOutTimeUntil: string;
  approvalDate: Date;
  paymentMethod: string;
  supplierName: string;
  hotelInformation: HotelInformation;
  roomTypes: RoomType[];
  bookerInformation: BookerInformation[];
  bookingPayment: PaymentInformation;
  approvalStatus: string;
  reason?: string;
  bookingCancellationCharge: BookingCancellationCharge;
  bookingStatus: string;
  wsReference: string;
  arrivalTime: string
  paymentType: string;
  travellerInformation: TravellerInformation[];

}
export class BookerInformation {
  fullName: string;
  phone: string;
  email: string;
  mainBooker: boolean;
  creditCardInformation?: CreditCardInformation;
  creditTermsInformation?: CreditTermsInformation;
  trueMoneyInformation?: TrueMoneyInformation;
  corporateFleetCardInformation?: FleetInformation;
  personalFleetCardInformation?: FleetInformation;
  checkoutFields?: CheckoutField[];
}

export class CreditCardInformation {
  taxAddressInformation: TaxAddressInformation;
  cancellationCharge: CancellationCharge;
  paymentInformation: PaymentInformationBooker;
}

export class TrueMoneyInformation {
  taxAddressInformation: TaxAddressInformation;
  cancellationCharge: CancellationCharge;
  paymentInformation: PaymentInformationBooker;
}

export class CreditTermsInformation {
  bookingApproval: BookingApproval;
  taxAddressInformation?: TaxAddressInformation;
  cancellationCharge: CancellationCharge;
  paymentInformation: PaymentInformationBooker;
}

export class FleetInformation {
  cancellationCharge: CancellationCharge;
  paymentInformation: PaymentInformation;
}

export class CancellationCharge {
  cancellationFee: number;
  cancellationFeeVat: number;
  cancellationFeeExVat: number;
  refundAmount?: number;
}

export class PaymentInformation {
  paymentMethod: string;
  payOnDate: number;
  totalPrice: number;
  discount?: number;
  totalPriceExcludeVat: number;
  totalVat: number;
  vat: number;
  currencyCode: string;
  paymentMethodDetail: PaymentMethodDetail;
  paymentMethodDisplay: string;
  taxesAndFees: number;
}

export class PaymentInformationBooker {
  totalPrice: number;
  totalPriceExcludeVat: number;
  totalVat: number;
  vat: number;
  currencyCode: string;
}

export class BookingApproval {
  fullName: string;
  email: string;
}

export class BookingCancellationCharge {
  cancelDate: number;
  cancellationFee: number;
  cancellationFeeVat: number;
  cancellationFeeExVat: number;
  cancelName: string;
  mainPaymentCancellationCharge?: CancellationCharge;
  anotherPaymentCancellationCharge?: CancellationCharge;
}

export class TravellerInformation {
  roomTypeName: string;
  travellers: Traveller[]
}

export class Traveller {
  name: string;
  checkoutFields: CheckoutField[];
  approval: Approval;
}

export class CheckoutField {
  fieldId: string;
  displayName: string;
  value: string;
}

export class Approval {
  approvalName: string;
  approvalEmail: string;
  approvalStatus: string;
}



// WEBPACK FOOTER //
// ./src/app/model/approval/approval-detail-model.ts